import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import LivePage from "../pages/liveSlot/LivePage";
import ProfilePage from "../pages/ProfilePage";
import RedirectClient from "../pages/redirectPath/Redirect";
import AddConfiguration from "../pages/addConfiguration/AddConfiguration";
import LoginForm from "../pages/LoginForm";
import { ROUTES } from "../constants/routes";
import { PrivateRoute } from "../components/privateRoute";

const AppRouters = () => {
  return (
    <Routes>

      {/* FIRST PAGE → LOGIN */}
      <Route path="/" element={<LoginForm />} />

      {/* REDIRECT PAGE (NO LAYOUT) */}
      <Route path={ROUTES.REDIRECT_PAGE} element={<RedirectClient />} />

      {/* PROTECTED PAGES WITH LAYOUT */}
      <Route element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route path={ROUTES.LIVE} element={<LivePage />} />
        <Route path={ROUTES.PROFILE_PAGE} element={<ProfilePage />} />
        <Route path={ROUTES.ADD_CONFIGURATION} element={<AddConfiguration />} />
      </Route>

      {/* ANY UNKNOWN PATH → LOGIN */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRouters;
